var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./notification-item.ts"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-222f0ab0\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./notification-item.vue.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/notification/notification-item/notification-item.vue.html
// module id = EWSY
// module chunks = 2